"use client"

import React from "react";

export const HighlightHighlighterTipIcon = ({className, fillColor}: {
    className?: string,
    fillColor?: string,
} & React.SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70.66 53.9" className={className}>
        <g>
            <polygon fill={fillColor || "currentColor"}
                     fillOpacity="0.5"
                     stroke="currentColor"
                     points="25.13 53.9 0 0 45.53 0 70.66 53.9 25.13 53.9"/>
        </g>
    </svg>
);
